import {
    Component,
    ElementRef,
    NgZone,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core';
import {AuthService} from './core/_services/auth.service';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {
    ActivatedRoute,
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Params,
    Router
} from '@angular/router';
import {UserService} from './core/_services/user.service';
import {UtilitiesService} from './core/_services/utilities.service';
import {quoteLabel, USER_EVENT_TYPE, FAB_NAVIGATION, ORGANIZATION_TYPES} from "./core/constants";
import 'moment-timezone';
import 'rxjs/add/operator/filter';
import {Angulartics2} from 'angulartics2';
import {EventTrackingService} from './core/_services/event-tracking.service';
import {Angulartics2Facebook} from 'angulartics2/facebook';
import {Angulartics2GoogleTagManager} from 'angulartics2/gtm';
import {environment} from '../environments/environment';
import * as Bowser from "bowser";
import {ConstantsService} from './core/_services/constants.service';
import {BannerService} from "./core/_services/banner.service";
import {Location} from "@angular/common";
import {User} from "app/shared/_models/user";
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {Role} from "./shared/_models/role";
import {RoleService} from "./core/_services/role.service";
import {WrenchBottomSheetService} from "./wrench-bottom-sheet/wrench-bottom-sheet.service";
import {
    WrenchBottomSheetFooterComponent
} from "./wrench-bottom-sheet/components/wrench-bottom-sheet-footer/wrench-bottom-sheet-footer.component";
import {ErrorsComponent} from "./widgets/errors/errors.component";

declare let window: any;
declare let navigator: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    routerStartSubscription: Subscription;
    routerEndSubscription: Subscription;
    userDataSubscription: Subscription;
    loggedInSubscription: Subscription;
    marketSubscription: Subscription;

    menu = false;
    submenu = "";
    market: string;
    marketPhone: string;
    promoCode = '';

    // urls
    helpUrl = $localize`/faq`;
    towingUrl = $localize`/service/towing-and-roadside-assistance`;
    fleetUrl = $localize`/fleet`;

    user: User = {} as User;
    loggedIn = false;
    loginName = "";
    readonly FAB_NAVIGATION = FAB_NAVIGATION;
    readonly ORGANIZATION_TYPES = ORGANIZATION_TYPES;

    get isBookingFlow() {
        const url = this.location.path().split('#').shift();
        return url.includes('book');
    }

    showHeaderFooter = true;

    pageBusy = false;

    component = 'app component';

    getQuoteLabel = quoteLabel.getQuoteLabel;
    getFleetQuoteLabel = quoteLabel.fleetLabel;

    @ViewChild('spinnerElement', { static: true })
    spinnerElement: ElementRef;
    currentYear: number;
    isFleetUrl: boolean = false;
    selectedRole: Role;
    constructor(public auth: AuthService,
        public userService: UserService,
        public eventTrackingService: EventTrackingService,
        private bannerService: BannerService,
        private angulartics2: Angulartics2,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private angulartics2Facebook: Angulartics2Facebook,
        private router: Router,
        private ngZone: NgZone,
        private renderer: Renderer2,
        private activatedRoute: ActivatedRoute,
        private constantsService: ConstantsService,
        private utilitiesService: UtilitiesService,
        private roleService: RoleService,
        private wrenchBottomSheetService: WrenchBottomSheetService,
        private location: Location) {

        this.angulartics2GoogleTagManager.startTracking();
        this.angulartics2Facebook.startTracking();
        this.constantsService.init().subscribe((success: boolean) => {
            if (!success) {
                this.showErrorModal('Uh oh!', 'We had a problem loading the page. Please refresh the page.');
            }
        });
        this.currentYear = new Date().getFullYear();
    } // constructor()

    checkBrowser() {
        const minBrowserVersions = {
            ie: ">=11",
            edge: ">=30",
            chrome: ">=30",
            firefox: ">=27",
            safari: ">=8",
            opera: ">=17",
            android: ">=5",
            ios: ">=8"
        };

        let prospectId = this.utilitiesService.getLocal("prospectId");
        if (UtilitiesService.isEmpty(prospectId) || prospectId == "null") {
            prospectId = 0;
        }

        let userId = this.auth.getUserIdFromToken();
        if (UtilitiesService.isEmpty(userId)) {
            userId = 0;
        }

        let userIp = this.utilitiesService.getLocal("ip");
        if (UtilitiesService.isEmpty(userIp)) {
            userIp = null;
        }

        const deviceDetails: any = Bowser.parse(window.navigator.userAgent);
        this.eventTrackingService.userDetails = {
            browser: deviceDetails.browser ? deviceDetails.browser.name : null,
            browserVersion: deviceDetails.browser ? deviceDetails.browser.version : null,
            oS: deviceDetails.os ? deviceDetails.os.name : null,
            device: deviceDetails.platform ? deviceDetails.platform.type : null,
            agent: window.navigator.userAgent,
            ipAddress: userIp
        };

        if (this.userService.unsupportedBrowser == null) {
            const bowser = Bowser.getParser(window.navigator.userAgent);
            if (!environment.app && !bowser.satisfies(minBrowserVersions)) {
                this.userService.unsupportedBrowser = 'UNSUPPORTED';

                // call backend api if unsupported
                let params: any = {
                    prospectId: prospectId,
                    userId: userId,
                    browser: deviceDetails.browser ? deviceDetails.browser.name : null,
                    browserVersion: deviceDetails.browser ? deviceDetails.browser.version : null,
                    oS: deviceDetails.os ? deviceDetails.os.name : null,
                    device: deviceDetails.platform ? deviceDetails.platform.type : null,
                    agent: window.navigator.userAgent,
                    ipAddress: userIp,
                    type: USER_EVENT_TYPE.UNSUPPORTED_BROWSER.value,
                    name: USER_EVENT_TYPE.UNSUPPORTED_BROWSER.label
                };
                this.eventTrackingService.userEvent(params).subscribe();
            }
            else {
                this.userService.unsupportedBrowser = 'SUPPORTED';
            }
        }

    } // checkBrowser()

    ngOnInit() {
        // app stuff
        if (environment.app) {
            if (navigator && navigator.splashscreen) {
                navigator.splashscreen.hide();
            }
            if (window.Keyboard) {
                document.addEventListener('deviceready', () => {
                    window.Keyboard.shrinkView(true);
                    window.Keyboard.disableScrollingInShrinkView(true);
                }, false);
            }
            let that = this;
            if (window.IonicDeeplink) {
                window.IonicDeeplink.route({}, (match: any) => {
                    console.log("We'll never get here.", match);
                }, function(nomatch: any) {
                    if (nomatch && nomatch.$link && nomatch.$link.path) {
                        that.router.navigate([nomatch.$link.path]);
                        return;
                    }
                });
            }
        }

        // harvest token out of url
        const params: any = this.getQueryParams();
        if (params.token) {
            this.auth.replaceCurrentToken(params.token).then(replacedToken => {
                if (replacedToken) {
                    this.userService.getUser().subscribe();
                }
            });
        }

        this.loggedInSubscription = this.auth.loggedInObservable().subscribe((response: any) => {
            setTimeout(() => {
                this.loggedIn = response;
                this.loginName = this.utilitiesService.getLocal("loginName");
            } , 0);
        });

        this.checkBrowser();

        this.loginName = this.utilitiesService.getLocal("loginName");

        this.marketSubscription = this.userService.market.subscribe((res: any) => {
            this.market = res;
        });

        this.marketPhone = this.utilitiesService.getLocal("marketPhone");

        this.routerStartSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe((event: NavigationStart) => {
                this.isFleetUrl = event.url === '/fleets';
                // enable spinner
                // run outside of Angular's zone to bypass change detection
                this.ngZone.runOutsideAngular(() => {
                    this.renderer.setStyle(
                        this.spinnerElement.nativeElement,
                        'display',
                        'block'
                    );
                });

                // refresh the session key everytime the user visits a page
                this.eventTrackingService.refreshSessionKey();

                this.userService.currentLocationRequested = event.url;
                if (event.url == "/activateaccount" && this.userService.previousLocationRequested != "/activateaccount") {
                    this.userService.redirectUrl = this.userService.previousLocationRequested;
                }
            });

        this.routerEndSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError))
            .subscribe((event: NavigationEnd) => {

                // turn off spinner
                // run outside of Angular's zone to bypass change detection
                this.ngZone.runOutsideAngular(() => {
                    this.renderer.setStyle(
                        this.spinnerElement.nativeElement,
                        'display',
                        'none'
                    );
                });

                if (event.url.indexOf("#") > -1 ) {
                    // do not scroll if there's a # in url and thus on quote flow
                } else {
                    setTimeout(() => window.scrollTo(0, 0), 0);
                }
                this.userService.previousLocationRequested = event.url;

                // hide header and footer on certain routes
                this.showHeaderFooter = !(event.url == '' || event.url == '/');
            });

        this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
            if (!this.utilitiesService.isEmpty(queryParams['promo'])) {
                try {
                    this.utilitiesService.setLocal("promoCodes", JSON.stringify([queryParams['promo']]));
                } catch (e) {
                    UtilitiesService.consoleLog(e);
                }
            }
        });

        // need to make sure we get fresh userData before rendering menus.
        this.userDataSubscription = this.userService.getUserData().subscribe(user => {
            setTimeout(() => this.user = user, 0);
            if (!this.utilitiesService.isEmpty(user)) {
                this.user = user;
            }
            this.savePromoCode();
        });

        this.roleService.selectedUserRole$.subscribe((role: Role) => {
            if (UtilitiesService.isNotEmpty(role)) {
                this.selectedRole = role;
            } else {
                this.selectedRole = null;
            }
        });
    } // ngOnInit()

    // we use this to get query params off the url.
    // ActivatedRouteSnapshot always returns {} and we don't want to wait for a subscription
    getQueryParams() {
        let params = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m: any, key: any, value: any) => {
            params[key] = decodeURI(value);
            return "";
        });
        return params;

    } // getQueryParams()

    ngOnDestroy() {
        this.routerStartSubscription.unsubscribe();
        this.routerEndSubscription.unsubscribe();
        this.userDataSubscription.unsubscribe();
        this.loggedInSubscription.unsubscribe();
        this.marketSubscription.unsubscribe();

    } // ngOnDestroy()

    toggleMenu() {
        this.menu = !this.menu;
        if (this.menu) {
            this.bannerService.hideBanner();
        } else {
            this.bannerService.showBanner();
        }
    } // toggleMenu()

    closeMenu() {
        this.bannerService.showBanner();
        this.menu = false;
    } // closeMenu()

    trackFbq() {
        this.angulartics2.eventTrack.next({action: 'InitiateCheckout'});
    } // trackFbq()

    private savePromoCode() {
        // save all promocodes from local storage
        let promoCodes = [];
        try {
            promoCodes = JSON.parse(this.utilitiesService.getLocal("promoCodes"));
        } catch (e) {
            UtilitiesService.consoleLog(e);
        }
        // add discount code if we have a promoCode and a logged in user
        if (!this.utilitiesService.isEmpty(promoCodes) && !this.utilitiesService.isEmpty(this.user) && !this.utilitiesService.isEmpty(this.user.id)) {
            promoCodes.forEach((promoCode: any) => {
                let params = {userId: this.user.id, promoCode: promoCode};
                this.userService.applyPromoCode(params).subscribe(
                    (result: any) => {
                        if (result.responseCode == 100) {
                            this.eventTrackingService.trackSuccessEvent(this.component, 'success', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/applypromocode', params, result.responseCode);
                        } else if (result.responseCode == 202) {
                            this.eventTrackingService.trackErrorEvent(this.component, 'error - invalid discount code', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/applypromocode', params, result.responseCode);
                        } else if (result.responseCode == 502) {
                            this.eventTrackingService.trackErrorEvent(this.component, 'error - ineligible for discount', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/applypromocode', params, result.responseCode);
                        } else {
                            this.eventTrackingService.trackErrorEvent(this.component, 'error', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/applypromocode', params, result.responseCode);
                        }
                    }, error => {
                        this.eventTrackingService.trackErrorEvent(this.component, 'error', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/applypromocode', params, error.responseCode);
                    });
            });
            this.utilitiesService.setLocal("promoCodes", "[]");
        } else if (UtilitiesService.isNotEmpty(promoCodes)
            && UtilitiesService.isNotEmpty(this.eventTrackingService.persistentKey)) {
            promoCodes.forEach((promoCode: any) => {
                let params: any = {
                    token: this.eventTrackingService.persistentKey,
                    promoCode: promoCode
                };
                this.userService.savePromoCode(params)
                    .subscribe(
                        (result: any) => {
                            if (result.responseCode == 100) {
                                this.eventTrackingService.trackSuccessEvent(this.component, 'success', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/savepromocode', params, result.responseCode);
                            } else if (result.responseCode == 202) {
                                this.eventTrackingService.trackErrorEvent(this.component, 'error - invalid discount code', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/savepromocode', params, result.responseCode);
                            } else if (result.responseCode == 502) {
                                this.eventTrackingService.trackErrorEvent(this.component, 'error - ineligible for discount', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/savepromocode', params, result.responseCode);
                            } else {
                                this.eventTrackingService.trackErrorEvent(this.component, 'error', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/savepromocode', params, result.responseCode);
                            }
                        }, error => {
                            this.eventTrackingService.trackErrorEvent(this.component, 'error', USER_EVENT_TYPE.ADD_DISCOUNT, '/transaction/savepromocode', params, error.responseCode);
                        });
            });
            this.utilitiesService.setLocal("promoCodes", "[]");
        }
    } // savePromoCode()

    private showErrorModal(header: string, message: string): void {
        this.wrenchBottomSheetService.open(ErrorsComponent, null, WrenchBottomSheetFooterComponent)
            .subscribe((bottomSheetRef: MatBottomSheetRef) => {
                bottomSheetRef.instance.content.errorHeader = header;
                bottomSheetRef.instance.content.errorMessage = message;
                bottomSheetRef.instance.content.showPhone = true;

                bottomSheetRef.instance.footer.primaryButtonText = "OK";
                bottomSheetRef.instance.footer.primaryButtonClick.subscribe(() => bottomSheetRef.dismiss());
            });
    } // showMixedServicesModal()

    isBannerVisible(): boolean {
        return this.bannerService.isBannerVisible();
    } // isBannerVisible()

    userIsFleet() {
        return (this.user?.organizationId === 0 && this.user?.fleet)
            || (this.user?.organizationId > 0 && (this.user?.orgType === ORGANIZATION_TYPES.FLEET));
    }

    logoClick() {
        window.location.href = "/";
    }
    callPhoneNumber() {
        window.open($localize`tel:+18449973624`);
    }
}
